import { render, staticRenderFns } from "./voice-typing.vue?vue&type=template&id=13f5f2bd&scoped=true"
import script from "./voice-typing.vue?vue&type=script&lang=js"
export * from "./voice-typing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f5f2bd",
  null
  
)

export default component.exports